function isPlantNewEwoFeatures(plantDesc) {
  const plants = ['ZEDELGEM'];
  return plants.includes(plantDesc);
}

function zedelgemCondition(user) {
  return user.plantdesc === 'ZEDELGEM' && [1, 4, 5, 8].includes(user.idprofilo);
}

export { isPlantNewEwoFeatures, zedelgemCondition };
